module.exports = __webpack_public_path__ + "img/temakinahaufnahme.14733fca.jpg";